import type * as React from "react";
import type { AnimatedSlideViewProps } from "./types";

export function AnimatedSlideView({
  style,
  onTransitionEnd,
  children,
  className,
}: AnimatedSlideViewProps) {
  return (
    <div
      className={className}
      style={style as React.CSSProperties}
      onTransitionEnd={onTransitionEnd}
    >
      {children}
    </div>
  );
}
